"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { AppBarCategory } from "@/components/icon/IconList";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { motion } from "framer-motion";
/**
 * 에디션 카테고리 플로팅 버튼
 * - md 미만 화면에서만 노출
 * - 하향 스크롤 시 비노출, 상향 스크롤 or 최상단일 때 노출
 * - 클릭 시 해당 에디션 카테고리의 drawer 노출
 */ export const CategoryFloatingButton = (param)=>{
    let { className , onClick  } = param;
    const isVisible = useScrollVisibility({
        mode: "direction",
        topThreshold: 10
    });
    return /*#__PURE__*/ _jsxs(motion.button, {
        type: "button",
        onClick: onClick,
        initial: {
            opacity: 1,
            y: 0
        },
        animate: {
            opacity: isVisible ? 1 : 0,
            y: isVisible ? 0 : 20
        },
        transition: {
            duration: 0.2,
            ease: "easeInOut"
        },
        className: cn("fixed bottom-6 left-1/2 z-[1100] -translate-x-1/2 md:hidden flex items-center gap-1.5 rounded-full bg-gray-700 px-5 py-3 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08),0px_4px_8px_0px_rgba(0,0,0,0.04)]", !isVisible && "pointer-events-none", className),
        "aria-label": "전체 리스트 보기",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: AppBarCategory,
                className: "size-[18px] [&_svg]:size-[18px] [&_svg_path]:fill-white"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                className: "text-white",
                children: "전체 리스트"
            })
        ]
    });
};
